import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { listAdminTeamCells } from "../lib/teamService";
import "../member-final.css";

export function AdminCellsPage() {
  const cells = useQuery({ queryKey: ["admin-team-cells"], queryFn: listAdminTeamCells });
  const totals = (cells.data ?? []).reduce((sum, cell) => ({
    memberCount: sum.memberCount + cell.memberCount,
    activeTasks: sum.activeTasks + cell.activeTasks,
    overdueTasks: sum.overdueTasks + cell.overdueTasks,
    approvedTasks: sum.approvedTasks + cell.approvedTasks,
    generatedUsd: sum.generatedUsd + cell.generatedUsd,
    managerOverrideUsd: sum.managerOverrideUsd + cell.managerOverrideUsd,
  }), { memberCount: 0, activeTasks: 0, overdueTasks: 0, approvedTasks: 0, generatedUsd: 0, managerOverrideUsd: 0 });

  return (
    <div className="member-app standalone-member-page">
      <header className="member-header">
        <Link className="member-logo" to="/admin"><span>H</span><b>CELL CONTROL</b></Link>
        <div className="member-header-actions"><Link to="/admin/workflows">WORKFLOWS</Link><Link to="/admin/payouts">PAYOUTS</Link><Link to="/admin">ADMIN HOME</Link></div>
      </header>
      <main>
        <section className="standalone-member-hero">
          <span>ADMIN · CELLS · VERIFIED OUTPUT</span>
          <h1>The farm dashboard.</h1>
          <p>Track who manages whom, which cells are late, and which overrides came from approved production.</p>
        </section>
        <section className="earnings-cards">
          <div><span>MEMBERS</span><strong>{totals.memberCount}</strong><small>IN CELLS</small></div>
          <div><span>ACTIVE</span><strong>{totals.activeTasks}</strong><small>TASKS NOW</small></div>
          <div><span>OVERDUE</span><strong>{totals.overdueTasks}</strong><small>NEED MANAGER</small></div>
          <div><span>OUTPUT</span><strong>${totals.generatedUsd.toFixed(0)}</strong><small>APPROVED VALUE</small></div>
        </section>
        <section className="team-cell-stack">
          {(cells.data ?? []).map((cell) => (
            <article className="team-cell-panel" key={cell.id}>
              <div className="team-cell-head">
                <div>
                  <span>{cell.route.toUpperCase()} CELL · {cell.memberCount} MEMBERS</span>
                  <h2>{cell.name}</h2>
                  <p>{cell.managerHandle} controls quality, delegation, and invite slots for this route cell.</p>
                </div>
                <strong>${cell.generatedUsd.toFixed(0)}<small>approved output</small></strong>
              </div>
              <div className="team-stats">
                <div><span>ACTIVE</span><b>{cell.activeTasks}</b></div>
                <div><span>OVERDUE</span><b>{cell.overdueTasks}</b></div>
                <div><span>APPROVED</span><b>{cell.approvedTasks}</b></div>
                <div><span>OVERRIDE</span><b>${cell.managerOverrideUsd.toFixed(2)}</b></div>
                <div><span>INVITES</span><b>{cell.inviteSlots}</b></div>
              </div>
              <div className="team-member-table">
                <div className="team-member-row header"><span>Member</span><span>Level</span><span>Trust</span><span>Late</span><span>Generated</span></div>
                {cell.members.map((member) => (
                  <div className={member.overdueTasks > 0 ? "team-member-row warning" : "team-member-row"} key={member.id}>
                    <strong>{member.handle}<small>{member.route.toUpperCase()}</small></strong>
                    <span>L{member.level}</span>
                    <span>{member.trustScore}</span>
                    <span>{member.overdueTasks}</span>
                    <b>${member.generatedUsd.toFixed(0)}</b>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </section>
      </main>
    </div>
  );
}
